export default class DeviceTypeService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('deviceType/' + id, params)
	}

	createEntity(params) {
		return this.apiService.callPost('deviceType/', params);
	}

	updateEntity(id, params) {
		return this.apiService.callPut('deviceType/' + id, params)
	}

	getEntitiesForSelectBox(params) {
		return this.apiService.callGet('deviceTypes/simple', params)
	}

	getEntities(params) {
		return this.apiService.callGet('deviceTypes', params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('deviceType/' + id, params)
	}

	getDependency() {
		return this.apiService.callGet('deviceType/dependency/')
	}
}



// WEBPACK FOOTER //
// ./src/service/DeviceTypeService.js